export default {"src":"/_next/static/media/bank-mastercard-square.44d3f4e7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};